import React, { Component } from 'react';

import { GOOGLE_API_KEY } from '../../../../utils/Constants';
import savedAddressMarker from '../../../../images/icons/pwa-saved-user-addresses.png';

class Map extends Component {
    constructor(props) {
        super(props);

        this.mapRef = React.createRef();
        this.initMap = this.initMap.bind(this);
        this.map = null;
    }

    componentDidMount() {
        if (!window.google || (window.google && window.google.accounts)) {
            window.initMap = this.initMap;
            
            const script = document.createElement('script');
            script.defer = 'defer';
            script.src = `https://maps.googleapis.com/maps/api/js?key=${GOOGLE_API_KEY}&callback=initMap&libraries=geometry&language=en`;

            document.body.appendChild(script);
        } else {
            this.initMap();
        }
    }

    componentDidUpdate(prevProps) {
        if ((this.props.customerSavedAddresses !== prevProps.customerSavedAddresses) && this.props.pwaAppRunning) {
            if (!window.google || (window.google && window.google.accounts)) {
                window.initMap = this.initMap;
                
                const script = document.createElement('script');
                script.defer = 'defer';
                script.src = `https://maps.googleapis.com/maps/api/js?key=${GOOGLE_API_KEY}&callback=initMap&libraries=geometry&language=en`;
    
                document.body.appendChild(script);
            } else {
                this.initMap();
            }
        }
    }

    componentWillUnmount() {
        if (this.props.onMapUnmount) {
            this.props.onMapUnmount();
        }
    }

    initMap() {
        let map = null;

        if (this.props.useGeocoder && this.props.useGeocoder === 'DECLINED') {

            const geocoder = new window.google.maps.Geocoder();
            geocoder.geocode({ 'address': this.props.brandCity ? this.props.brandCity : this.props.brandCountry }, (results, status) => {
                if (status === window.google.maps.GeocoderStatus.OK && results && results.length > 0 && results[0].geometry && results[0].geometry.location && results[0].geometry.location.lat() && results[0].geometry.location.lng()) {

                    const positionFromGoogleApi = {
                        lat: results[0].geometry.location.lat(),
                        lng: results[0].geometry.location.lng()
                    };

                    this.props.handleAddressData(results, positionFromGoogleApi);

                    map = new window.google.maps.Map(document.getElementById('pwaMainScreenMap'), {
                        ...this.props.options,
                        center: positionFromGoogleApi
                    });

                    // Add user saved addresses to map
                    this.setSavedAddressesMarkersOnMap(map);

                    this.addMapListeners(map);
                }
            });
        } else {

            map = new window.google.maps.Map(document.getElementById('pwaMainScreenMap'), this.props.options);

            if (!this.props.hasFullAddress && map) {
                this.props.handleMapChange(map);
            }

            // Add user saved addresses to map
            if (map) {
                this.setSavedAddressesMarkersOnMap(map);
                this.addMapListeners(map);
            }
        }
    }

    addMapListeners(map) {
        this.map = map;
        if (this.props.onMapReady) {
            this.props.onMapReady(map);
        }

        // Listen for zooming
        window.google.maps.event.addListener(map, 'zoom_changed', () => {
            this.props.handleMapChange(map);
        });
        // Listen for dragging the map around
        window.google.maps.event.addListener(map, 'dragend', () => {
            this.props.handleMapChange(map);
        });
        // Listen for map idle (after all animations/movements complete)
        window.google.maps.event.addListener(map, 'idle', () => {
            this.resetMapOverlays();
        });
        
        // Reset overlays after map init and again later (iOS can add overlays after first paint)
        setTimeout(() => this.resetMapOverlays(), 500);
        setTimeout(() => this.resetMapOverlays(), 1500);
    }

    rectsIntersect(a, b) {
        return !(a.right < b.left || a.left > b.right || a.bottom < b.top || a.top > b.bottom);
    }

    // Disable pointer-events on map overlays that block the address bar, but never on the main
    // map layer (full-size), so panning still works.
    resetMapOverlays() {
        const mapContainer = document.getElementById('pwaMainScreenMap');
        if (!mapContainer) return;

        const mapRect = mapContainer.getBoundingClientRect();
        const uiEl = document.getElementById('infoMainContainer');
        const uiRect = uiEl ? uiEl.getBoundingClientRect() : null;
        const maxSize = Math.min(mapRect.width, mapRect.height) * 0.6;

        const overlayDivs = mapContainer.querySelectorAll('div:not([class]):not([id])');
        overlayDivs.forEach(div => {
            const divRect = div.getBoundingClientRect();
            const extendsAboveMap = divRect.top < mapRect.top;
            const overlapsUi = uiRect && this.rectsIntersect(divRect, uiRect);
            const isSmallOverlay = divRect.width <= maxSize && divRect.height <= maxSize;
            if (extendsAboveMap || (overlapsUi && isSmallOverlay)) {
                div.style.pointerEvents = 'none';
            }
        });
    }

    setSavedAddressesMarkersOnMap(map) {

        if (!this.props.customerSavedAddresses.length) return [];

        this.props.customerSavedAddresses.map(address => {

            let marker = new window.google.maps.Marker({
                position: new window.google.maps.LatLng(address.latitude, address.longitude),
                map,
                icon: savedAddressMarker
            });
        });
    }

    render() {
        return (
            <div id={this.props.id} ref={this.mapRef} />
        );
    }
}

export default Map;